import { FilterSection, L2FilterOption } from 'ace/filterSection';

export const parseFilterParam = function (param: string | undefined | null): string[] | undefined {
    return param?.split(';').filter(Boolean);
};

export const calculateSectionTotal = (options: L2FilterOption[]): number => {
    return options.reduce((sectionLength: number, option: L2FilterOption) => {
        if (option.isL2Filter) {
            sectionLength += option.options?.length || 0;
        } else {
            sectionLength += 1;
        }
        return sectionLength;
    }, 0);
};

export const totalFilterSearchResults = (filterSections: FilterSection[]) => {
    return filterSections.reduce((acc: number, section: FilterSection) => {
        const options = section.options as L2FilterOption[];
        const sectionTotal = calculateSectionTotal(options);
        acc += sectionTotal;
        return acc;
    }, 0);
};
